import LangStorageManager from "./LangStorageManager";

export default class LanguageManager {
    constructor(lang) {
        const storage = new LangStorageManager(lang);
        this.language = storage.getStorage();
        this.translation = {};
    }

    async loadTranslation() {
        try {
            const data = await import(`./locales/${this.language}.json`);
            this.translation = data.default;
        } catch (e) {
            console.error(`Error con traducir: ${this.language}\n${e}`);
            this.translation = {};
        }
    }

    getAll() {
        return this.translation;
    }
}
